import React from 'react'
import {Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Modal,} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import InvoicesView from "./InvoicesView";
import EditInvoiceSettingsView from "./EditInvoiceSettingsView";
import lsHelpers from "../../helpers/LsHelper";
import Select from "react-select";
import resourceHelper from "../../helpers/ResourceHelper";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import businessHelper from "../../helpers/BusinessHelper";
import PartnerSearch from "../Search/PartnerSearch";
import businessApiService from "../../api/business-api-service";
import stringHelpers from "../../helpers/StringHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class EditInvoiceView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showStudentsModal: false,
            invoiceId: this.props.invoiceId || null,
            selectedPaymentType: null,
            invoice: resourceHelper.emptyInvoice(),
            validation: {
                start: true,
                end: true
            },
        };
    }

    deleteInvoice = this.deleteInvoice.bind(this);
    handleChange = this.handleChange.bind(this);

    componentDidMount() {
        if (this.state.invoiceId) {
            this.getInvoice()
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        let generatedItem = this.state.invoice.invoice_item

        switch (targetId) {
            case "input-item-name":
                generatedItem.title = newValue

                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        invoice_item: generatedItem
                    }
                }));
                break;
            case "input-item-qty":
                generatedItem.qty = newValue

                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        invoice_item: generatedItem
                    }
                }));
                break;
            case "input-item-price":
                let value = newValue === "" ? "0" : newValue
                generatedItem.price = parseFloat(value.replace(/,/g, '-.'));

                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        invoice_item: generatedItem
                    }
                }));
                break;
            case "input-partner-name":

                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        client_name: newValue
                    }
                }));
                break;
            case "input-partner-id":

                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        client_id: newValue
                    }
                }));
                break;
            case "input-partner-email":

                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        client_email: newValue
                    }
                }));
                break;
            case "input-partner-address":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        client_address: newValue
                    }
                }));
                break;
            case "input-date":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        date: newValue
                    }
                }));
                break;
            case "input-invoice-prefix":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        prefix: newValue
                    }
                }));
                break;
            case "input-invoice-number":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        number: newValue
                    }
                }));
                break;
            default:
                return null;
        }
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showInvoiceModal &&
                    this.renderInvoiceSettingsModal()
                    }

                    {this.state.showStudentsModal &&
                    this.renderStudentSearchModal()
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Col lg="12">
                        <CardBody>
                            <Button
                                className="mb-2 justify-content-end"
                                color="secondary"
                                outline={true}
                                onClick={e => this.props.closeEditInvoiceView(e)}
                                size="sm"
                            >
                                {commonStrings.close}
                            </Button>
                            <Form>
                                <h6 className="heading-small text-muted mb-4">
                                    {resourceStrings.invoices.invoice_data}
                                </h6>
                                <div className="pl-lg-4">
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-item-name"
                                                >
                                                    {resourceStrings.invoices.item_title}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange}
                                                    defaultValue={this.itemTitle()}
                                                    id="input-item-name"
                                                    placeholder={resourceStrings.invoices.item_title}
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3">
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-item-qty"
                                            >
                                                {resourceStrings.qty}
                                            </label>
                                            <FormGroup>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange}
                                                    value={this.state.invoice.invoice_item.qty}
                                                    id="input-item-qty"
                                                    placeholder="1"
                                                    type="number"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3">
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-item-price"
                                            >
                                                {resourceStrings.price} {businessHelper.currency()}
                                            </label>
                                            <FormGroup>
                                                <Input
                                                    className="form-control-alternative"
                                                    onChange={this.handleChange}
                                                    value={this.state.invoice.invoice_item.price}
                                                    id="input-item-price"
                                                    type="number"
                                                    min={0}
                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                    placeholder="0.00"
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                {/*<label*/}
                                                {/*    className="form-control-label"*/}
                                                {/*>*/}
                                                {/*    {commonStrings.payment_method}*/}
                                                {/*</label>*/}
                                                {/*<Row>*/}
                                                {/*    <Col lg="6">*/}
                                                {/*        <Select*/}
                                                {/*            style={{*/}
                                                {/*                position: 'absolute',*/}
                                                {/*                top: '50%',*/}
                                                {/*                transform: 'translateY(-50%)'*/}
                                                {/*            }}*/}
                                                {/*            className="form-control-alternative"*/}
                                                {/*            placeholder={commonStrings.select}*/}
                                                {/*            value={this.getPaymentMethod()}*/}
                                                {/*            onChange={this.handleInvoiceTypeSelected}*/}
                                                {/*            options={paymentTypeHelpers.paymentTypes()}*/}
                                                {/*        />*/}
                                                {/*    </Col>*/}
                                                {/*    <Col lg="6" style={{*/}
                                                {/*        display: "flex",*/}
                                                {/*        alignItems: "center"*/}
                                                {/*    }}>*/}
                                                {/*        <span className="btn-inner--icon" style={{*/}
                                                {/*            position: 'absolute',*/}
                                                {/*            top: '50%',*/}
                                                {/*            transform: 'translateY(-50%)'*/}
                                                {/*        }}>*/}
                                                {/*            {this.state.selectedPaymentType &&*/}
                                                {/*            <div*/}
                                                {/*                className="icon icon-shape bg-white text-white rounded-circle shadow">*/}
                                                {/*                <img*/}
                                                {/*                    width={24}*/}
                                                {/*                    height={24}*/}
                                                {/*                    alt="pm"*/}
                                                {/*                    src={this.getPaymentMethodIcon()}*/}
                                                {/*                />*/}
                                                {/*            </div>}*/}
                                                {/*         </span>*/}
                                                {/*    </Col>*/}
                                                {/*</Row>*/}

                                                <label
                                                    className="form-control-label"
                                                >
                                                    {resourceStrings.invoices.invoice_type}
                                                </label>
                                                <Row>
                                                    <Col lg="6">
                                                        <Select
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)'
                                                            }}
                                                            className="form-control-alternative"
                                                            placeholder={commonStrings.select}
                                                            value={this.getPaymentMethod()}
                                                            onChange={this.handleInvoiceTypeSelected}
                                                            options={paymentTypeHelpers.invoiceTypes()}
                                                        />
                                                    </Col>
                                                </Row>

                                                <label
                                                    className="form-control-label mt-6 text-white">
                                                    {resourceStrings.invoices.invoice_for}</label>

                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-partner-name"
                                                            >
                                                                {resourceStrings.title} / {commonStrings.name}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.invoice.client_name}
                                                                id="input-partner-name"
                                                                placeholder={`${resourceStrings.title} / ${commonStrings.name}`}
                                                                type="text"
                                                            />
                                                        </FormGroup>

                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label text-default"
                                                            >
                                                                {"."}
                                                            </label>
                                                            <Row className="ml-0">
                                                                <Button
                                                                    color="info"
                                                                    onClick={e => this.toggleStudentsModal()}
                                                                    size="sm"
                                                                >
                                                                    {resourceStrings.invoices.select_partner}
                                                                </Button>
                                                            </Row>
                                                        </FormGroup>

                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col lg="8">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-partner-address"
                                                            >
                                                                {commonStrings.address}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.invoice.client_address}
                                                                id="input-partner-address"
                                                                placeholder={commonStrings.address}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col lg="4">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-partner-id"
                                                            >
                                                                {commonStrings.id_number}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.invoice.client_id}
                                                                id="input-partner-id"
                                                                placeholder={`XXX-000`}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-partner-email"
                                                            >
                                                                {commonStrings.email}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                defaultValue={this.state.invoice.client_email}
                                                                id="input-partner-email"
                                                                placeholder={commonStrings.address}
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <small
                                                    className="text-white mt--2">*{resourceStrings.invoices.data_saved_expl}</small>

                                                <Row>
                                                <label
                                                    className="form-control-label mt-5 text-white">
                                                    {resourceStrings.invoices.invoice_number_prefix} & {resourceStrings.invoices.invoice_number}</label>
                                                </Row>

                                                <Row>
                                                    <Col lg="3">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-invoice-prefix"
                                                            >
                                                                {resourceStrings.invoices.invoice_number_prefix}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                value={this.state.invoice.prefix}
                                                                id="input-invoice-prefix"
                                                                placeholder="XXX"
                                                                type="text"
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col lg="3">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-invoice-number"
                                                            >
                                                                {resourceStrings.invoices.invoice_number}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                value={this.state.invoice.number}
                                                                id="input-invoice-number"
                                                                placeholder={`001`}
                                                                type="number"
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col lg="3">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-date"
                                                            >
                                                                {commonStrings.date}
                                                            </label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                onChange={this.handleChange}
                                                                value={dateHelpers.cleanup(this.state.invoice.date)}
                                                                id="input-date"
                                                                placeholder={`001`}
                                                                type="date"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>

                                <hr className="my-4"/>
                            </Form>
                            <Row className="align-items-end">
                                <Col className="text-right" xs="12">
                                    <Button
                                        color="secondary"
                                        outline={true}
                                        onClick={e => this.props.closeEditInvoiceView(e)}
                                        size="lg"
                                    >
                                        {commonStrings.close}
                                    </Button>
                                    <Button
                                        color="warning"
                                        onClick={e => this.handleSubmit(e)}
                                        size="lg"
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    handleSubmit() {
        const i = this.state.invoice

        i.title = this.state.invoice.invoice_item.title
        i.qty = this.state.invoice.invoice_item.qty
        i.price = this.state.invoice.invoice_item.price

        if (this.state.invoice.id) {
            businessApiService.update_invoice(i)
                .then(res => {
                    businessHelper.saveUserSession(res)
                    this.setState({
                        isLoading: false,
                    });

                    this.props.closeEditInvoiceView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        } else {
            businessApiService.create_invoice(i)
                .then(res => {
                    businessHelper.saveUserSession(res)
                    this.setState({
                        isLoading: false,
                    });

                    this.props.closeEditInvoiceView()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportStats() {
        return (this.state.invoiceData ? this.state.invoiceData.length : "0") + " " + resourceStrings.cabinet.invoices
    }

    setPeriod() {
        lsHelpers.setReportDateStart(dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()));
        lsHelpers.setReportDateEnd(dateHelpers.databaseDate(dateHelpers.lastDayOfMonth()));
        return {
            start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
            end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
        };
    }

    getData() {
        if (this.datesAreValid()) {
            this.setState({isLoading: true, invoiceData: null});

            reportApiService.invoices(this.state.period)
                .then(res => {
                    this.setState({
                        invoiceData: res,
                        isLoading: false,
                        showSearchButton: false
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    deleteInvoice(e, invoice) {
        e.preventDefault();

        reportApiService.deleteInvoice(invoice.id)
            .then(res => {
                this.getData();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    onInvoiceSelected(invoice) {
        reportApiService.invoiceLink(invoice.id)
            .then(res => {
                window.open(`https://app.openmanagerapp.com/invoices/invoice.pdf?sc=${res}`, "_blank")
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    handleValidation() {
        this.validateDates();
    }

    validateDates() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: start <= end,
                    end: start <= end,
                }
            }));
        } else {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: dateHelpers.isValidDate(start),
                    end: dateHelpers.isValidDate(end),
                }
            }));
        }
    }

    datesAreValid() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            return start <= end
        } else {
            return dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)
        }
    }

    toggleInvoiceModal = state => {
        this.setState({
            showInvoiceModal: !this.state.showInvoiceModal
        });
    };

    closeEditInvoiceSettingsView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showInvoiceModal: false});
    }

    renderInvoiceSettingsModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showInvoiceModal}
                toggle={() => this.toggleInvoiceModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.invoices.invoice_settings}</h4>
                                <small>{resourceStrings.invoices.invoice_settings_expl}</small>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditInvoiceSettingsView
                                closeEditInvoiceSettingsView={this.closeEditInvoiceSettingsView.bind(this)}
                                handleError={this.handleNetworkError}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }


    itemTitle() {
        return this.state.invoice && this.state.invoice.invoice_item ?
            this.state.invoice.invoice_item.title : ""
    }

    itemPrice() {
        const price = this.state.invoice && this.state.invoice.invoice_item ?
            this.state.invoice.invoice_item.price : 0.00

        return price
    }

    getPaymentMethod() {
        if (this.state.invoice) {
            if (this.state.invoice.ticket_id) return {value: 't', label: resourceStrings.tickets}
            else if (this.state.invoice.income_id) return {
                value: 'i',
                label: stringHelpers.capitalize(resourceStrings.incomes)
            }
            else if (this.state.invoice.expense_id) return {
                value: 'e',
                label: stringHelpers.capitalize(resourceStrings.cabinet.expenses)
            }
            else return {value: 'o', label: resourceStrings.categories.other}
        } else {
            return {value: 'o', label: resourceStrings.categories.other}
        }
    }

    handleInvoiceTypeSelected = selectedOption => {
        switch (selectedOption.value) {
            case "t":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        ticket_id: -1
                    }
                }));
                break;
            case "i":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        income_id: -1
                    }
                }));
                break
            case "o":
                this.setState(prevState => ({
                    invoice: {
                        ...prevState.invoice,
                        ticket_id: null,
                        income_id: null,
                    }
                }));
                break
            default:
                break;
        }
    };

    getPaymentMethodIcon() {
        const ppt = paymentTypeHelpers.paymentTypes();
        if (this.state.selectedPaymentType) {
            return this.state.selectedPaymentType.icon
        } else {
            if (this.state.ticket.pt) {
                const pt = ppt.find(p => p.value === this.state.ticket.pt);
                if (pt) {
                    return pt.icon
                } else {
                    return ppt[ppt.length - 2].icon
                }
            } else {
                return ppt[ppt.length - 2].icon
            }
        }
    }

    closeStudentSearchView(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            showStudentsModal: false
        });
    }

    toggleStudentsModal = state => {
        this.setState({
            showStudentsModal: !this.state.showStudentsModal
        });
    };

    renderStudentSearchModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showStudentsModal}
                toggle={() => this.toggleStudentsModal()}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.invoices.select_partner}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <PartnerSearch
                                closeStudentSearchView={this.closeStudentSearchView.bind(this)}
                                addStudent={this.onPartnerSelected.bind(this)}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    onPartnerSelected(partner) {
        this.setState(prevState => ({
            showStudentsModal: false,
            invoice: {
                ...prevState.invoice,
                client_name: partner.name,
                client_address: partner.address,
                client_id: partner.dni,
                partner_id: partner.id,
            }
        }));
    }

    getInvoice() {
        this.setState({
            isLoading: true,
        });

        reportApiService.invoice(this.state.invoiceId)
            .then(res => {
                let i = res;
                i.invoice_item.price = parseFloat(i.invoice_item.price).toFixed(2);
                this.setState({
                    invoice: i,
                    isLoading: false,
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getDate() {
        const iDate = this.state.invoice.date
        const res = dateHelpers.databaseDate(new Date(iDate))
        return res
    }
}

EditInvoiceView.propTypes = propTypes;